import LeaveSummary from 'views/dashboard/personal-dashboard/LeaveSummary';
import DatePicker from 'components/base/DatePicker';
import { Col, Row } from 'react-bootstrap';
// import { stats } from 'data/dashboard/stats';
// import Stat from 'views/dashboard/Stat';
// import ProjectDashboard from 'views/dashboard/ProjectDashboard';
import dayjs from 'dayjs';
import PunchInOutCard from 'views/dashboard/personal-dashboard/PunchInOutCard';
import AttendanceSummary from 'views/dashboard/personal-dashboard/AttendanceSummary';
import EmployeeAttendanceListDetails from 'views/dashboard/personal-dashboard/EmployeeAttendanceListDetails';
import LeaveRequests from 'views/dashboard/personal-dashboard/LeaveRequests';
import Icon from 'components/icon';
import LoadComponent from 'components/custom/animate-component/LoadComponent';
import { useEffect, useState } from 'react';
import fetchData from 'services/fetchData';
import { formatTimeToAmPm, getUserData } from 'services/utils';
import Button from 'components/base/Button';
import useManagePageLoading from 'hooks/custom/useManagePageLoading';
import useFetchData from 'hooks/custom/useFetchData';
import apiEndpoints from 'constants/apiEndpoints';
import PageLoader from 'components/custom/animate-component/PageLoader';

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(false);
  const [pageLoading, loadingText, handlePageLoading] = useManagePageLoading();
  const [employeeData, empLoading] = useFetchData(
    apiEndpoints.employee.getById(getUserData('user_id'))
  );

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const userId = getUserData('user_id');
      try {
        const request = await fetchData(
          `https://kalyanierp.com/kalyani-api-v2.1/mobile/user/dashboards/get_detail/${userId}?user_type=Employee`,
          { isStatic: true }
        );
        if (request.status) {
          setDashboardData(request.data);
          setLoading(false);
        } else {
          setDashboardData({});
          setLoading(false);
        }
      } catch (error) {
        setDashboardData({});
        setLoading(false);
      }
    };
    fetch();
  }, []);

  const refreshData = async () => {
    setLoading(true);
    const userId = getUserData('user_id');
    try {
      const request = await fetchData(
        `https://kalyanierp.com/kalyani-api-v2.1/mobile/user/dashboards/get_detail/${userId}?user_type=Employee`,
        { isStatic: true }
      );
      if (request.status) {
        setDashboardData(request.data);
        setLoading(false);
      } else {
        setDashboardData({});
        setLoading(false);
      }
    } catch (error) {
      setDashboardData({});
      setLoading(false);
    }
  };

  return (
    <>
      <Row className="gy-3 mb-6 justify-content-between">
        <Col md={9} xs="auto">
          <h2 className="mb-2 text-1100">Hello, {getUserData('user_name')}!</h2>
          <h5 className="text-700 fw-semi-bold">
            We hope today is a great day for you.
          </h5>
        </Col>
        <Col
          md={3}
          xs="auto"
          className="d-flex flex-row gap-2 justify-content-between justify-content-md-end align-items-md-center"
        >
          <DatePicker
            options={{
              defaultDate: dayjs().format('MMM DD, YYYY')
            }}
          />
          <Button
            className="p-2 px-2 position-relative"
            disabled={loading}
            variant="phoenix-primary"
            title="Refresh table"
            onClick={refreshData}
          >
            <Icon icon={'heroicons-outline:refresh'} />
          </Button>
        </Col>
      </Row>
      <Row className="mb-5 gx-3 gy-4">
        <Col lg={12} xl={5}>
          <LoadComponent
            key={'stats1'}
            containerClassName=""
            height={180}
            count={1}
            loading={loading}
          >
            <PunchInOutCard
              data={dashboardData}
              refreshData={refreshData}
              handlePageLoading={handlePageLoading}
            />
          </LoadComponent>
        </Col>
        <Col xs={12} sm={6} xl={3}>
          <LoadComponent
            key={'stats2'}
            containerClassName=""
            height={180}
            count={1}
            loading={loading}
          >
            <AttendanceSummary
              data={dashboardData?.attendance_summary || null}
            />
          </LoadComponent>
        </Col>
        <Col xs={12} sm={6} xl={4}>
          <LoadComponent
            key={'stats3'}
            containerClassName=""
            height={180}
            count={1}
            loading={loading}
          >
            <LeaveSummary data={employeeData} />
          </LoadComponent>
        </Col>
      </Row>

      <LoadComponent
        key={'stats4'}
        containerClassName="row align-items-center mb-5 gx-3 gy-3"
        height={75}
        wrapper={({ children }) => (
          <Col xs={12} md={6} lg={3}>
            {children}
          </Col>
        )}
        count={4}
        loading={loading || empLoading}
      >
        <Row className="mb-5 gx-3 gy-3">
          <Col xs={12} md={6} lg={3}>
            <div className="px-3 py-3 rounded-3 bg-primary-100">
              <div className="d-flex align-items-center gap-2">
                <div
                  className="circle d-flex flex-center rounded-circle bg-primary text-bg-primary"
                  style={{ width: '40px', height: '40px' }}
                >
                  <Icon icon={'ph:building-light'} />
                </div>
                <div>
                  <h5 className=" text-1000">Branch</h5>
                  <p className="mb-0 text-800 fs-8">
                    {employeeData?.professional_details?.branch_name || '--'}
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3}>
            <div className="px-3 py-3 rounded-3 bg-info-100">
              <div className="d-flex align-items-center gap-2">
                <div
                  className="circle d-flex flex-center rounded-circle bg-info text-bg-info"
                  style={{ width: '40px', height: '40px' }}
                >
                  <Icon
                    icon={'material-symbols-light:home-work-outline-rounded'}
                  />
                </div>
                <div>
                  <h5 className=" text-1000">Working Location</h5>
                  <p className="mb-0 text-800 fs-8">
                    {employeeData?.professional_details?.loc_area_name || '--'}
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3}>
            <div className="px-3 py-3 rounded-3 bg-warning-100">
              <div className="d-flex align-items-center gap-2">
                <div
                  className="circle d-flex flex-center rounded-circle bg-warning text-bg-warning"
                  style={{ width: '40px', height: '40px' }}
                >
                  <Icon icon={'material-symbols-light:id-card-outline'} />
                </div>
                <div>
                  <h5 className=" text-1000">Designation</h5>
                  <p className="mb-0 text-800 fs-8 text-capitalize">
                    {employeeData?.professional_details?.designation_name ||
                      '--'}
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3}>
            <div className="px-3 py-3 rounded-3 bg-200">
              <div className="d-flex align-items-center gap-2">
                <div
                  className="circle d-flex flex-center rounded-circle bg-800 text-bg-secondary"
                  style={{
                    width: '40px',
                    height: '40px',
                    minWidth: '40px',
                    minHeight: '40px'
                  }}
                >
                  <Icon icon={'iconamoon:clock-thin'} />
                </div>
                <div>
                  <h5 className=" text-1000">Shift</h5>
                  <p className="mb-0 text-800 fs-8">
                    {employeeData?.professional_details?.start_time &&
                    employeeData?.professional_details?.end_time
                      ? `${formatTimeToAmPm(
                          employeeData.professional_details?.start_time
                        )} to ${formatTimeToAmPm(
                          employeeData.professional_details?.end_time
                        )}`
                      : '-- to --'}{' '}
                    {/* <small>(10:00 Am to 6:00 Pm)</small> */}
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </LoadComponent>
      <Row className="mb-5 gx-3 gy-4">
        <Col xs={12} xl={7}>
          <LoadComponent
            key={'stats6'}
            containerClassName=""
            height={400}
            count={1}
            loading={loading}
          >
            <EmployeeAttendanceListDetails
              employeeId={employeeData?.personal_information?.employee_id}
            />
          </LoadComponent>
        </Col>
        <Col xs={12} xl={5}>
          <LoadComponent
            key={'stats7'}
            containerClassName=""
            height={400}
            count={1}
            loading={loading}
          >
            <LeaveRequests
              userId={getUserData('user_id')}
              employeeId={employeeData?.personal_information?.employee_id}
            />
          </LoadComponent>
        </Col>
      </Row>
      <PageLoader loading={pageLoading} loadingMessage={loadingText} />
    </>
  );
};

export default Dashboard;
